import {Component, effect, input, output, signal, Signal} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {FormInputComponent} from "../../utils/form-input/form-input.component";
import {TranslateModule} from "@ngx-translate/core";
import {EmployeeModel} from "../../../models/resources/employee.model";
import {CheckboxInputComponent} from "../../utils/checkbox-input/checkbox-input.component";

@Component({
  selector: 'app-employee-form',
  imports: [
    ReactiveFormsModule,
    FormInputComponent,
    TranslateModule,
    CheckboxInputComponent
  ],
  templateUrl: './employee-form.component.html',
  styleUrl: './employee-form.component.scss',
})
export class EmployeeFormComponent {
  formGroupOutput = output<FormGroup>();
  formGroup: Signal<FormGroup>;
  employee = input<EmployeeModel>();

  constructor(
    private formBuilder: FormBuilder,
  ) {
    this.formGroup = signal(this.formBuilder.group({
      vitabeneId: [null, [Validators.required]],
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      abbreviation: [null, []],
      isNurse: [false, []]

    }));

    effect(() => {
      this.formGroupOutput.emit(this.formGroup());
    });

    effect(() => {
      if (this.employee())
        this.updateFormValues();
    });
  }

  updateFormValues() {
    const currentModel = this.employee();

    if(currentModel) {
      this.formGroup().patchValue({
        vitabeneId: currentModel.vitabeneId,
        firstName: currentModel.firstName,
        lastName: currentModel.lastName,
        abbreviation: currentModel?.abbreviation,
        isNurse: currentModel.isNurse
      });
    }
  }
}
